import React, { FC, useContext } from 'react';
import { connectRefinementList } from 'react-instantsearch-dom';

import { Col, Container, Row } from 'layout';
import Arrow from 'common/icons/arrow-right.svg';
import CustomCarousel from 'components/CustomCarousel';
import { MOST_VIEWED_TABLET } from 'utils/constants';

import ScreenRecognitionContext from '../../contexts/screenRecognitionContext';
import { PolicyMostViewedBoxesProps } from './models';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import '../PopularTopics/PopularTopics.scss';

const RefinementList = ({ mostViewedItems, refine, title, onHandleClear, prepareForClear }) => {
  const { isTablet, isMobile, isSmallMobile } = useContext(ScreenRecognitionContext);

  const cards = mostViewedItems?.map((item, i) =>
    i === MOST_VIEWED_TABLET && isTablet ? null : (
      <Col
        className="popular-topics__col col--no-gutters"
        key={item.policyDetailCategory.name}
        xl="3"
        md="4"
      >
        <div className="popular-topics__card">
          {React.createElement(
            title ? 'h3' : 'h2',
            {
              className: 'popular-topics__card-title h6',
            },
            item.policyDetailCategory.name
          )}

          <button
            type="button"
            className="popular-topics__cta link link--black-white"
            onClick={async () => {
              await onHandleClear();
              await refine(item.policyDetailCategory.name);
              prepareForClear();
            }}
          >
            {item.buttonText}
            <Arrow aria-hidden="true" />
          </button>
        </div>
      </Col>
    )
  );

  const carousel = (
    <CustomCarousel autoPlay infiniteLoop showArrows={false} showStatus={false} showThumbs={false}>
      {mostViewedItems?.map((item) => (
        <div className="popular-topics__card" key={item.policyDetailCategory.name}>
          {React.createElement(
            title ? 'h3' : 'h2',
            {
              className: 'popular-topics__card-title h6',
            },
            item.policyDetailCategory.name
          )}
          <button
            type="button"
            className="popular-topics__cta link link--black-white"
            onClick={async () => {
              await onHandleClear();
              await refine(item.policyDetailCategory.name);
              prepareForClear();
            }}
          >
            {item.buttonText}
            <Arrow aria-hidden="true" />
          </button>
        </div>
      ))}
    </CustomCarousel>
  );

  return (
    <section className="popular-topics">
      <Container>
        <Row>
          {title ? (
            <Col className="col--no-gutters">
              <h2 className="popular-topics__title h6">{title}</h2>
            </Col>
          ) : null}
        </Row>
        <Row>{isMobile || isSmallMobile ? carousel : cards}</Row>
      </Container>
    </section>
  );
};

const CustomMostViewed = connectRefinementList(RefinementList);

const PolicyMostViewedBoxes: FC<PolicyMostViewedBoxesProps> = ({
  items,
  title,
  onHandleClear,
  prepareForClear,
}) => (
  <CustomMostViewed
    mostViewedItems={items}
    title={title}
    attribute="category.name"
    onHandleClear={onHandleClear}
    prepareForClear={prepareForClear}
  />
);

export default PolicyMostViewedBoxes;
